import { echartSetOption } from './echarts-utils';

const epsNextYearChartInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const $chartEl = document.querySelector('.echart-eps-next-year-chart');

  if ($chartEl) {
    const userOptions = getData($chartEl, 'echarts');
    const chart = window.echarts.init($chartEl);
    const getDefaultOptions = () => ({
      series: [
        {
          radius: '75%',
          type: 'pie',
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          data: [
            {
              value: 800,
              name: 'This Year',
              itemStyle: {
                color: getColor('color-info-lighter')
              }
            },
            {
              value: 1200,
              name: 'Next Year',
              itemStyle: {
                color: getColor('color-info-light')
              }
            }
          ]
        }
      ],
      tooltip: {
        trigger: 'item',
        padding: [7, 10],
        backgroundColor: getColor('background-color-subtle'),
        borderColor: getColor('border-color-default'),
        textStyle: { color: getColor('text-color-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        }
      },
      grid: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        outerBoundsMode: 'none'
      }
    });
    echartSetOption(chart, userOptions, getDefaultOptions);

    document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
      tab.addEventListener('shown.bs.tab', () => {
        setTimeout(() => {
          chart.resize();
        }, 100);
      });
    });
  }
};

export default epsNextYearChartInit;
